import { _ } from "core-js"
import Vue from "vue"
import tenant from "@shared/lib/Http"
/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    recipients: [],
    emailTemplates: [],
    allEmailTemplates: [],
    smsTemplates: [],
    allSmsTemplates: [],
    triggers: [],
    allTriggers: [],
    tags: [],
    allTags: [],
    templatesLoaded: false,
    cappedSmsTemplate: false,
    smsTextMaxLength: 320,
    email: {
        applicationId: Ambition.applicationId(),
        sendEmail: true,
        delaySending: false,
        sendAt: null,
        canSendEmail: false,
        sendSms: false,
        delaySendSms: false,
        canSendSms: false,
        recipients: [],
        emailAction: null,
        emailActionData: null,
        smsAction: null,
        smsActionData: null,
        cc: [],
        bcc: [],
        task: {},
        manual: false,
        team_id: null,
        user_id: Ambition.userId()
    },
    emailRecipients: [],
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {

    // ====================================
    // Email Templates
    // ====================================
    getEmailTemplates: state => {
        return state.emailTemplates
    },
    getActiveEmailTemplates: state => {
        return _.sortBy(state.allEmailTemplates.filter(template => template.active == 1), 'weight')
    },

    // ====================================
    // SMS Templates
    // ====================================
    getSmsTemplates: state => {
        return state.smsTemplates
    },
    getActiveSmsTemplates: state => {
        return _.sortBy(state.allSmsTemplates.filter(template => template.active == 1), 'weight')
    },
    getCappedSmsTemplate: state => {
        return state.cappedSmsTemplate
    },
    smsTextMaxLength: state => {
        return state.smsTextMaxLength
    },

    // ====================================
    // Action Triggers
    // ====================================
    getTriggers: state => {
        return state.triggers
    },
    getActiveTriggers: state => {
        return state.allTriggers.filter(trigger => trigger.active == 1)
    },

    // ====================================
    // Merge Tags
    // ====================================
    getTags: state => {
        return state.tags
    },
    getActiveTags: state => {
        return state.allTags.filter(tag => tag.active == 1)
    },

    // ====================================
    // Email
    // ====================================
    getEmail: state => {
        state.email.team_id = Ambition.Globals.tenant.currentTeamId
        state.email.applicationId = $store.getters.appId ? $store.getters.appId : ''
        return state.email
    },
    getRecipients: state => {
        return state.emailRecipients
    },
    checkTemplatesLoaded: state => {
        return state.templatesLoaded
    },
    getApplicationId: state => {
        console.log('applicationId', state.applicationId)
        return state.applicationId
    },
    getEmailIsManual: state => {
        state.email.manual = state.email.manual ? state.email.manual : true
        return state.email
    }
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {

    // ====================================
    // Email Templates
    // ====================================
    setEmailTemplates(state, data) {
        state.emailTemplates = data
    },
    setAllEmailTemplates(state, data) {
        state.allEmailTemplates = data
    },
    createEmailTemplate(state, data) {
        state.emailTemplates.data.push(data)
    },
    updateEmailTemplate(state, data) {
        state.emailTemplates.data = state.emailTemplates.data.map(template => (template.uid == data.uid ? { ...template, ...data } : template))
    },
    deleteEmailTemplate(state, data) {
        let key = state.emailTemplates.data.findIndex(template => template.uid === data.uid)
        Vue.delete(state.emailTemplates.data, key);
    },

    // ====================================
    // SMS Templates
    // ====================================
    setSmsTemplates(state, data) {
        state.smsTemplates = data
    },
    setAllSmsTemplates(state, data) {
        state.allSmsTemplates = data
    },
    createSmsTemplate(state, data) {
        state.smsTemplates.data.push(data)
    },
    updateSmsTemplate(state, data) {
        state.smsTemplates.data = state.smsTemplates.data.map(template => (template.uid == data.uid ? { ...template, ...data } : template))
    },
    deleteSmsTemplate(state, data) {
        let key = state.smsTemplates.data.findIndex(template => template.uid === data.uid)
        Vue.delete(state.smsTemplates.data, key);
    },
    setCappedSmsTemplate(state, data) {
        state.cappedSmsTemplate = data
    },


    // ====================================
    // Action Triggers
    // ====================================
    setTriggers(state, data) {
        state.triggers = data
    },
    setAllTriggers(state, data) {
        state.allTriggers = data
    },
    createTrigger(state, data) {
        state.triggers.data.push(data)
    },
    updateTrigger(state, data) {
        state.triggers.data = state.triggers.data.map(trigger => (trigger.uid == data.uid ? { ...trigger, ...data } : trigger))
    },
    deleteTrigger(state, data) {
        let key = state.triggers.data.findIndex(trigger => trigger.uid === data.uid)
        Vue.delete(state.triggers.data, key);
    },

    // ====================================
    // Merge Tags
    // ====================================
    setTags(state, data) {
        state.tags = data
    },
    setAllTags(state, data) {
        state.allTags = data
    },
    createTag(state, data) {
        state.tags.data.push(data)
    },
    updateTag(state, data) {
        state.tags.data = state.tags.data.map(tag => (tag.uid == data.uid ? { ...tag, ...data } : tag))
    },
    deleteTag(state, data) {
        let key = state.tags.data.findIndex(tag => tag.uid === data.uid)
        Vue.delete(state.tags.data, key);
    },

    // ====================================
    // Email
    // ====================================
    resetEmail(state, data) {
        state.email = data
        state.email.applicationId = $store.getters.appId ? $store.getters.appId : ''
    },
    setEmail(state, data) {
        state.email = data
    },
    setRecipients(state, data) {
        state.email.recipients = data
    },
    setCc(state, data) {
        state.email.cc = data
    },
    setBcc(state, data) {
        state.email.bcc = data
    },
    setExtraRecipients(state, data) {
        state.email.extraRecipients = data
    },
    setEmailRecipients(state, data) {
        state.emailRecipients = data
    },
    setSendEmail(state, data) {
        state.email.sendEmail = data
    },
    setSendSms(state, data) {
        state.email.sendSms = data
    },
    setApplicationId(state, applicationId) {
        state.email.applicationId = applicationId ? applicationId : $store.getters.appId
    },
    setEmailIsManual(state, manual) {
        state.email.manual = manual ? manual : true
    },
    setTemplatesLoaded(state, loading) {
        state.templatesLoaded = loading
    },
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */
const actions = {
    getEmails({ dispatch, commit, state }, data) {
        dispatch("getTemplates", data)
        dispatch("getTriggers", data)
        dispatch("getTags", data)
    },

    // ====================================
    // Email Templates
    // ====================================
    setEmailTemplates({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/get-templates", data).then(
                response => {
                    commit("setEmailTemplates", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setAllEmailTemplates({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/get-templates", { all: true }).then(
                response => {
                    commit("setAllEmailTemplates", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    saveEmailTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/save-template", data).then(
                response => {
                    if (data.form.id) {
                        commit("updateEmailTemplate", response.data)
                    } else {
                        commit("createEmailTemplate", response.data)
                    }
                    dispatch("setAllEmailTemplates")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    deleteEmailTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/delete-template", data).then(
                response => {
                    commit("deleteEmailTemplate", response.data)
                    if (!response.data.tenantTemplate) {
                        commit("createEmailTemplate", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setEmailActiveState({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/activate-template", data).then(
                response => {
                    commit("updateEmailTemplate", response.data)
                    dispatch("setAllEmailTemplates")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    copyEmailTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/copy-template", data).then(
                response => {
                    if (data.master) {
                        commit("deleteEmailTemplate", response.data)
                        commit("createEmailTemplate", response.data)
                    } else {
                        commit("createEmailTemplate", response.data)
                    }
                    dispatch("setAllEmailTemplates")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    duplicateEmailTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-templates/duplicate-template", data)
                .then(response => {
                    commit("createEmailTemplate", response.data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // ====================================
    // SMS Templates
    // ====================================
    setSmsTemplates({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/get-templates", data).then(
                response => {
                    commit("setSmsTemplates", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setAllSmsTemplates({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/get-templates", { all: true }).then(
                response => {
                    commit("setAllSmsTemplates", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    copySmsTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/copy-template", data).then(
                response => {
                    if (data.master) {
                        commit("deleteSmsTemplate", response.data)
                        commit("createSmsTemplate", response.data)
                    } else {
                        commit("createSmsTemplate", response.data)
                    }
                    dispatch("setAllSmsTemplates")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    saveSmsTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/save-template", data).then(
                response => {
                    if (data.form.id) {
                        commit("updateSmsTemplate", response.data)
                    } else {
                        commit("createSmsTemplate", response.data)
                    }
                    dispatch("setAllSmsTemplates")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setSmsActiveState({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/activate-template", data).then(
                response => {
                    commit("updateSmsTemplate", response.data)
                    dispatch("setAllSmsTemplates")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    deleteSmsTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/delete-template", data).then(
                response => {
                    commit("deleteSmsTemplate", response.data)
                    if (!response.data.tenantTemplate) {
                        commit("createSmsTemplate", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    setCappedSmsTemplate({ dispatch, commit, state }, data) {
        commit("setCappedSmsTemplate", data)
    },

    duplicateSmsTemplate({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/sms-templates/duplicate-template", data)
                .then(response => {
                    commit("createSmsTemplate", response.data)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // ====================================
    // Action Triggers
    // ====================================
    setTriggers({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-triggers/get-triggers", data).then(
                response => {
                    commit("setTriggers", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setAllTriggers({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-triggers/get-triggers", { all: true }).then(
                response => {
                    commit("setAllTriggers", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    copyTrigger({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-triggers/copy-trigger", data).then(
                response => {
                    if (data.master) {
                        commit("deleteTrigger", response.data)
                        commit("createTrigger", response.data)
                    } else {
                        commit("createTrigger", response.data)
                    }
                    dispatch("setAllTriggers")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    saveTrigger({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-triggers/save-trigger", data).then(
                response => {
                    if (data.form.id) {
                        commit("updateTrigger", response.data)
                    } else {
                        commit("createTrigger", response.data)
                    }
                    dispatch("setAllTriggers")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setTriggerActiveState({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-triggers/activate-trigger", data).then(
                response => {
                    commit("updateTrigger", response.data)
                    dispatch("setAllTriggers")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    deleteTrigger({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-triggers/delete-trigger", data).then(
                response => {
                    commit("deleteTrigger", response.data)

                    if (!response.data.tenantTemplate) {
                        commit("createTrigger", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    // ====================================
    // Merge Tags
    // ====================================
    setTags({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-tags/get-tags", data).then(
                response => {
                    commit("setTags", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setAllTags({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-tags/get-tags", { all: true }).then(
                response => {
                    commit("setAllTags", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    copyTag({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-tags/copy-tag", data).then(
                response => {
                    if (data.master) {
                        commit("deleteTag", response.data)
                        commit("createTag", response.data)
                    } else {
                        commit("createTag", response.data)
                    }
                    dispatch("setAllTags")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    saveTag({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-tags/save-tag", data).then(
                response => {
                    if (data.form.id) {
                        commit("updateTag", response.data)
                    } else {
                        commit("createTag", response.data)
                    }
                    dispatch("setAllTags")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setTagActiveState({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-tags/activate-tag", data).then(
                response => {
                    commit("updateTag", response.data)
                    dispatch("setAllTags")
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    deleteTag({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios.post("/admin/settings/email-tags/delete-tag", data)
                .then(response => {
                    commit("deleteTag", response.data)
                    if (data.source == 'team' && response.data.source == 'default-local' ||
                        ['default'].includes(response.data.source)) {
                        commit("createTag", response.data)
                    }
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    // ====================================
    // Email
    // ====================================
    resetEmail({ dispatch, commit, state }, data) {
        commit("resetEmail", {
            applicationId: Ambition.applicationId(),
            emailAction: null,
            emailActionData: null,
            smsAction: null,
            smsActionData: null,
            sendEmail: true,
            delaySending: false,
            sendAt: null,
            canSendEmail: false,
            sendSms: false,
            delaySendSms: false,
            canSendSms: false,
            recipients: [],
            cc: [],
            bcc: [],
            task: {},
            manual: false,
            team_id: null,
            user_id: Ambition.userId()
        })
    },
    setEmail({ dispatch, commit, state }, data) {
        commit("setEmail", data)
    },
    setRecipients({ dispatch, commit, state }, data) {
        commit("setRecipients", data)
    },
    setCc({ dispatch, commit, state }, data) {
        commit("setCc", data)
    },
    setBcc({ dispatch, commit, state }, data) {
        commit("setBcc", data)
    },
    setExtraRecipients({ dispatch, commit, state }, data) {
        commit("setExtraRecipients", data)
    },
    fetchEmailRecipients({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            let appId = $store.getters.appId

            if (typeof appId === "undefined") {
                appId = _.has(data, "applicationId") ? data.applicationId : state.email.applicationId
            }

            let manual = true

            if (typeof manual === "undefined") {
                manual = _.has(data, "manual") ? state.email.manual : state.email.manual
            }

            if (typeof appId !== "undefined" && appId) {
                commit("setApplicationId", appId)
                tenant.get("/api/recipients/" + appId).then(response => {
                    let data = response.data.map(res => {
                        res.id = `${res.group}-${res.id}`
                        return res
                    })
                    commit("setEmailRecipients", data)
                    resolve(response)
                })
                .catch(error => {
                    error.output()
                })
            } else {
                commit("setEmailIsManual", manual)
            }
        })
    },
    searchUsers({ dispatch, commit, state }, data) {
        return new Promise((resolve, reject) => {
            axios
                .get("/api/recipients/manual", {
                    params: {
                        search: data
                    }
                })
                .then(
                    response => {
                        let data = response.data.map(res => {
                            res.id = `${res.group}-${res.id}`
                            return res
                        })
                        data = _.uniqBy(data, "id")
                        commit("setEmailRecipients", data)
                        resolve(response)
                    },
                    error => {
                        reject(error)
                    }
                )
        });
    },
    setSendEmail({ dispatch, commit, state }, data) {
        commit("setSendEmail", data)
    },
    setSendSms({ dispatch, commit, state }, data) {
        commit("setSendSms", data)
    },
    setApplicationId({ dispatch, commit, state }, applicationId) {
        commit("setApplicationId", applicationId)
    },
    setEmailIsManual({ dispatch, commit, state }, manual) {
        commit("setEmailIsManual", manual)
    },
    setTemplatesLoaded({ dispatch, commit, state }, loading) {
        commit("setTemplatesLoaded", loading)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
